import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useFetch from 'use-http';

import 'react-html5-camera-photo/build/css/index.css';
import { imagebase64 } from 'utils/imagebase64';
import Button from 'components/UI/Button';
import Camera from 'components/Camera';
import { dataURItoBlob, registrCheckinAnother } from 'utils/helpers';
import styles from './styles.module.scss';

import moment from 'moment';
import { $qrcode, $store, setQRCode } from 'models/store';
import { useUnit } from 'effector-react';
import { $coordinate, $noCoord } from 'models/user';

export default function PhotoUser() {
	const noCoord = useUnit($noCoord);
	const { post, get } = useFetch();
	const navigate = useNavigate();
	const { userId } = useParams();
	const [loading, setLoading] = React.useState(false);

	const store = useUnit($store);
	const coordinate = useUnit($coordinate);
	const qrcode = useUnit($qrcode);

	const getCode = React.useCallback(async () => {
		if (store) {
			const qrcodeData = await get(`/api/qrcode/byStoreId?storeId=${store.id}`);
			setQRCode(qrcodeData.code);
			return qrcodeData;
		}
	}, [store, setQRCode]);

	React.useEffect(() => {
		if (!qrcode && store) {
			getCode();
		}
	}, [qrcode, store]);

	const [facingMode, setFacingMode] = React.useState(false);

	const handleClick = React.useCallback(() => {
		setFacingMode(!facingMode);
	}, [setFacingMode, facingMode]);

	const [image, setImage] = React.useState('');

	const handleTakePhoto = React.useCallback(
		(dataUri: string) => {
			setImage(dataUri);
		},
		[setImage],
	);

	const datetime = moment(new Date()).format('YYYY-MM-DD HH:mm');

	const handleSave = React.useCallback(async () => {
		setLoading(true);
		const file = dataURItoBlob(image);
		const body = new FormData();
		body.append('file', file, 'image.jpg');

		const imageRes = await post('api/file/download', body);

		if (imageRes) {
			try {
				const diffGeoRes = await post('/api/checkin/diffGeo', {
					code: qrcode,
					lat: coordinate?.latitude,
					lon: coordinate?.longitude,
				});

				if (diffGeoRes?.statusCode) {
					throw new Error(diffGeoRes.message || 'Ошибка при сохранении уведомления нарушения координат');
				}

				if (!userId) {
					throw new Error('Пользователь не найден');
				}

				if (noCoord) {
					await registrCheckinAnother(post, qrcode, userId, imageRes.id);
					setLoading(false);
					navigate('/qrcode');
				} else if (!coordinate?.latitude || !coordinate?.longitude || diffGeoRes) {
					setLoading(false);
					navigate(`/manual/maps/${qrcode}/${userId}/${imageRes.id}`);
				} else {
					await registrCheckinAnother(post, qrcode, userId, imageRes.id, coordinate);
					setLoading(false);
					navigate(`/qrcode`);
				}
			} catch (err) {
				setLoading(false);
				navigate('/qrcode');
				console.error(err);
			}
		} else {
			setLoading(false);
			navigate('/qrcode');
		}
	}, [image, qrcode, userId, datetime, setLoading]);

	return (
		<div className={styles.wrap}>
			{image ? (
				<div>
					<div className="row">
						<div className="column-xs-12">
							<img alt="img" src={image} style={{ width: 'auto', margin: 'auto' }} />
						</div>
					</div>
					<div className="row">
						<div className="column-xs-12">
							<Button variant="green" type="button" onClick={() => setImage('')} style={{ margin: 'auto' }}>
								Повторить
							</Button>
						</div>
						<div className="column-xs-12">
							<Button variant="green" disabled={loading} type="button" onClick={handleSave} style={{ margin: 'auto' }}>
								{loading ? 'Загрузка...' : 'Зарегистрировать приход/уход сотрудника вручную'}
							</Button>
						</div>
					</div>
				</div>
			) : (
				<div>
					<Button type="button" onClick={handleClick} style={{ margin: '10px auto' }}>
						Смена камеры
					</Button>
					<Camera handleTakePhoto={handleTakePhoto} facingMode={facingMode} />
					<div style={{ margin: '40px' }}>
						<p>Дата и время регистрации прихода/ухода</p>
						<p>{datetime}</p>
						<br />
						<p>Сделайте фото исполнителя во входной зоне универмага (перед вывеской Фамилия)</p>
					</div>
				</div>
			)}
		</div>
	);
}
